import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Careers.module.css';
import Footer from '../shared/Footer';

const COMPANY_HIGHLIGHTS = [
  {
    icon: '🌍',
    title: 'Global Presence',
    description: 'A team of 50+ professionals across 6 countries, from Canada and Australia to Hong Kong, Singapore, and beyond.'
  },
  {
    icon: '👩‍💻',
    title: 'Diversity & Inclusion',
    description: 'Empowering Women in Tech, with almost 40% of our team made up of women, and fostering a culture built on diverse backgrounds and perspectives.'
  },
  {
    icon: '🚀',
    title: 'Innovation & Growth',
    description: 'Be part of cutting-edge AI innovation in aviation with rapid learning and career growth opportunities.'
  },
  {
    icon: '🏠',
    title: 'Hybrid Work Environment',
    description: 'A flexible, collaborative culture balancing in-office and remote work across global locations.'
  }
];

// ===== HARDCODED DATA (FALLBACK) =====
const DEFAULT_JOBS = [
  {
    id: 1,
    title: "AI Engineer (Operations Research)",
    category: "Engineering",
    featured: true,
    type: "Full-time or Internship",
    description: "Work on real aviation challenges using optimization, algorithms, and data. Ideal for those skilled in Python, operations research, and solvers like Gurobi. A great fit if you enjoy problem-solving and want to grow fast in a startup.",
    workMode: "Remote",
    location: "Singapore"
  }
];

// ===== DATA LOADING =====
async function loadCareersData() {
  try {
    const response = await fetch('/content/careers/index.json');
    if (!response.ok) {
      throw new Error('Failed to load careers data');
    }
    const cmsJobs = await response.json();
    
    // Merge CMS jobs with default jobs (CMS takes priority)
    const allJobs = [...DEFAULT_JOBS, ...cmsJobs];
    return allJobs;
  } catch (error) {
    console.error('Error loading careers data, using default:', error);
    return DEFAULT_JOBS;
  }
}

function Careers() {
  const [jobs, setJobs] = useState(DEFAULT_JOBS);
  const [loading, setLoading] = useState(true);

  // Load careers data on component mount
  useEffect(() => {
    loadCareersData().then(data => {
      setJobs(data);
      setLoading(false);
    });
  }, []);
  return (
    <div className={styles.section}>
      <div 
        className={styles.hero}
        style={{ 
          backgroundImage: `url(${process.env.PUBLIC_URL + '/images/news/NLBD.png'})` 
        }}
      >
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <h1 className={styles.title}>Join Our Team</h1>
          <p className={styles.subtitle}>
            We're building the future of airport operations with AI. Join our diverse team of innovators, engineers, and visionaries who are passionate about transforming the aviation industry through cutting-edge technology.
          </p>
        </div>
      </div>
      <div className={styles.container}>
        {/* Company Highlights Section */}
        <div className={styles.highlightsSection}>
          <div className={styles.container}>
            <h2 className={styles.highlightsTitle}>Why Join Neural Lab?</h2>
            <div className={styles.highlightsGrid}>
              {COMPANY_HIGHLIGHTS.map((highlight, index) => (
                <div key={index} className={styles.highlightCard}>
                  <div className={styles.highlightIcon}>{highlight.icon}</div>
                  <h3 className={styles.highlightTitle}>{highlight.title}</h3>
                  <p className={styles.highlightDescription}>{highlight.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Job Opportunities Section */}
        <div className={styles.positionsSection}>
          <div className={styles.container}>
            <h2 className={styles.positionsTitle}>Job Opportunities</h2>
            {loading ? (
              <div className={styles.loading}>Loading job opportunities...</div>
            ) : jobs.length === 0 ? (
              <div className={styles.noJobs}>No job opportunities available at the moment.</div>
            ) : (
              <div className={styles.jobsGrid}>
                {jobs.map((job, index) => (
                  <div key={index} className={styles.jobCard}>
                    <div className={styles.jobHeader}>
                      <span className={styles.jobCategory}>{job.category}</span>
                      {job.featured && <span className={styles.featuredBadge}>Featured</span>}
                    </div>
                    <h3 className={styles.jobTitle}>{job.title}</h3>
                    <div className={styles.jobDetails}>
                      <span className={styles.jobType}>{job.type}</span>
                      <span className={styles.jobLocation}>{job.location}</span>
                    </div>
                    <div className={styles.jobWorkMode}>
                      <span className={styles.workModeLabel}>Work Mode:</span>
                      <span className={styles.workModeValue}>{job.workMode}</span>
                    </div>
                    <p className={styles.jobDescription}>{job.summary || job.description}</p>
                    <Link to={`/job-details/${job.slug || index}`} className={styles.applyBtn}>Apply Now</Link>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Careers;
